import { render, staticRenderFns } from "./JoalProduce.vue?vue&type=template&id=d624f2ce&"
import script from "./JoalProduce.vue?vue&type=script&lang=js&"
export * from "./JoalProduce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports